import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Notification } from '@models/notifications/notification.model';

import { environment } from '../../../environments/environment';

@Injectable()
export class NotificationService {
  baseHref = `${environment.apiUrl}/notifications`;

  constructor(private http: HttpClient) {}

  getNewNotificationCount(): Observable<number> {
    const url = `${this.baseHref}/new`;
    return this.http.get<number>(url);
  }

  getNewNotificationsPaginated(
    pageSize: number,
    pageNumber: number,
  ): Observable<Notification> {
    const url = `${this.baseHref}/`;
    let params;
    if (pageSize && pageNumber) {
      params = new HttpParams()
        .set('pageSize', pageSize.toString())
        .set('pageNumber', pageNumber.toString());
    }
    return this.http.get<Notification>(url, { params });
  }

  getNewTaskNotificationsPaginated(
    pageSize: number,
    pageNumber: number,
  ): Observable<Notification> {
    const url = `${this.baseHref}/new-task`;
    let params;
    if (pageSize && pageNumber) {
      params = new HttpParams()
        .set('pageSize', pageSize.toString())
        .set('pageNumber', pageNumber.toString());
    }
    return this.http.get<Notification>(url, { params });
  }

  readNotification(id: number): Observable<Notification> {
    if (!id || !Number.isInteger(id)) {
      throw new Error('Invalid notification id provided');
    }
    const url = `${this.baseHref}/${id}`;
    return this.http.get<Notification>(url);
  }

  markAllNotificationsAsRead(): Observable<any> {
    const url = `${this.baseHref}/read-all`;
    return this.http.get(url);
  }

  boostNewTaskAfterOneDayNotifyInstantHandyhanders(taskId: number) {
    const url = `${this.baseHref}/boost-my-task/${taskId}`;
    return this.http.get(url);
  }
}
